/**
 * ajax请求封装
 * created by 李智惠 2020-11-4
 */
// 引入axios 和 qs
import axios from 'axios';
import qs from 'qs';
import { Loading, Message } from 'element-ui';
import { DownloadRestResultDTO } from './DownloadRestResultDTO'
import { isNull } from '../utils/validateBase'
import config from '../../package.json'
// 引入本地存储 
import session from '@/utils/session';
import { versionList } from '@/config/version'
import moment from 'moment';
import { SystemTime } from '@/config/systemTime'

import apiTrackJson from '/public/apiTrack.json'

const getNestedValue = (obj, path, defaultValue = '') => {
  const keys = typeof path === 'string' ? path.split('.') : path;
  
  let result = obj;
  for (let i = 0; i < keys.length; i++) {
    if (result === null || result === undefined) {
      return defaultValue;
    }
    result = result[keys[i]];
  }
  
  return result === undefined ? defaultValue : result;
}

const apiTrackIntercept = (interceptType, url, params) => {
  const list = apiTrackJson.data   

	const interceptMap = list.find(v => { return v.url === url && v.interceptType === interceptType })

	if (interceptMap) {
		let options = {}
		interceptMap.options.forEach(v => {
			if (!['', undefined, null].includes(v.value)) {
				options[v.key] = v.value
			} else {
				if (!['', undefined, null].includes(v.path)) {
					options[v.key] = getNestedValue(params, v.path)
				}
			}
		})

		let data = {}
		interceptMap.data.forEach(v => {
			if (!['', undefined, null].includes(v.value)) {
				data[v.key] = v.value
			} else {
				if (!['', undefined, null].includes(v.path)) {
					data[v.key] = getNestedValue(params, v.path)
				}
			}
		})

		window.$trackTool.track(options, data)
	}
}

axios.defaults.timeout = 5 * 60 * 1000;
// 请求拦截器
axios.interceptors.request.use(request => {
    // request.timeout = isNull(request.timeout) ? 60000 : request.timeout;
    // request.timeout = isNull(request.timeout) ? 1000 : request.timeout;
    // 统一携带token
    let token = session.get('t_k') || null;
    let ybDeptNum = session.get('ybDeptNum') || ''
    if (token) request.headers.Authorization = token;
    if (token) request.headers['Dept-Num'] = ybDeptNum;
    if (!isNull(process.env.VUE_APP_VERSION)) request.headers['Ctui-Version'] = process.env.VUE_APP_VERSION;
    // 统一配置get请求的参数转化
    if (request.method === 'get') {
        request.paramsSerializer = function(params) {
                return qs.stringify(params, { arrayFormat: 'repeat' });
            }
            // 如果参数params存在，设置deptId，删除值为空的参数
        if (request.params != undefined) {
            if (!request.params.deptId) {
                request.params.deptId = session.get("deptId") || null;
            }
            if ([0,-1,'all'].includes(request.params.deptId)) {
                request.params.deptId = null
            }
            for (let key in request.params) {
                if (request.params[key] == null || request.params[key] == '') delete request.params[key];
            }
        }
    }
		apiTrackIntercept('request', request.url, { request: request.params, response: {} })
    return request;
})

// 响应拦截器 统一设置弹窗信息
axios.interceptors.response.use(response => {
    let url = response.config.url
    session.set('version', response.headers['ctui-version'])
    let resTime = moment(response.headers.date).valueOf()
    SystemTime.correctDiffValue(resTime)
    if (response.data.hasOwnProperty('code') && response.data.hasOwnProperty('msg')) {
        let urlList = ['http://127.0.0.1:8802/query_disease','http://127.0.0.1:8802/query_cum']
        let { code, msg } = response.data;
        if (code != 200 && msg != null && code != 206 && code != 204 && !urlList.includes(url)) {
            if (url.includes('http://127.0.0.1:8802')) {
                Message.error(`医保错误：${msg}`);
            } else {
                Message.error({
                    message: msg.replace(/(\n|\r|\n\r|↵)/g, '<br/>'),
                    dangerouslyUseHTMLString: true,
                });
            }
        }
        if (code == 401) setTimeout(() => {
            session.clear();
            location.href = "/login";
            clearTimeout();
        }, 500);
    }
		if (response.status === 200) {
            try {
                const requestMap = response.config.method === 'get' ? (response.config.params || {}) : (response.config.data && JSON.parse(response.config.data) || {})
                const responseMap = response.data
                apiTrackIntercept('response', response.config.url, { request: requestMap, response: responseMap })
            } catch (error) {}
		}
    return response;
})
const baseUrl = process.env.NODE_ENV === 'development' ? '' : process.env.VUE_APP_BASEURL;
const shebaoUrl = process.env.NODE_ENV === 'development' ? '/shebaoUrl' : process.env.VUE_APP_MEDICAL_URL;
const voiceUrl = process.env.NODE_ENV === 'development' ? '/voiceUrl' : process.env.VUE_APP_VOICE_URL;
const printUrl = process.env.NODE_ENV === 'development' ? '/printUrl' : process.env.VUE_APP_PRINT_URL;
// ajax 封装
const req = {
    // get请求
    // config 可选，透传 axios 配置；不传时沿用全局 timeout（默认 5 分钟）
    // 示例：req.get('/xxx', { id: 1 }, '/api', { timeout: 30000 })
    get(url, params = {}, pre = '/api', config = {}) {
        return new Promise((resolve, reject) => {
            axios.get(baseUrl + pre + url, { ...config, params })
                .then(response => { resolve(response.data) })
                .catch(err => { reject(err) })
        })
    },
    // delete请求
    // 示例：req.delete('/xxx', { id: 1 }, '/api', { timeout: 30000 })
    delete(url, params = {}, pre = '/api', config = {}) {
        return new Promise((resolve, reject) => {
            axios.delete(baseUrl + pre + url, { ...config, params })
                .then(response => { resolve(response.data) })
                .catch(err => { reject(err) })
        })
    },
    // post请求
    // 第 4 参：字符串为 contentType（兼容旧写法）；对象则视为 config
    // 第 5 参：config（在第 4 参为 contentType 时使用）
    // 示例：
    //   req.post('/xxx', params, '/api', { timeout: 30000 })
    //   req.post('/xxx', params, '/api', 'multipart/form-data', { timeout: 30000 })
    post(url, params = {}, pre = '/api', contentType = 'application/json;charset=UTF-8', config = {}) {
        let finalContentType = 'application/json;charset=UTF-8'
        let finalConfig = {}
        if (contentType && typeof contentType === 'object') {
            finalConfig = contentType
        } else {
            finalContentType = contentType || finalContentType
            finalConfig = config || {}
        }
        const headers = {
            'Content-Type': finalContentType,
            ...(finalConfig.headers || {})
        }
        return new Promise((resolve, reject) => {
            axios.post(baseUrl + pre + url, params, { ...finalConfig, headers })
                .then(response => { resolve(response.data) })
                .catch(err => { reject(err) })
        })
    },
    // post请求
    uploadPost(url, params = {}, pre = '/api', headers) {
        return new Promise((resolve, reject) => {
            axios.post(baseUrl + pre + url, params, { headers })
                .then(response => { resolve(response.data) })
                .catch(err => { reject(err) })
        })
    },
    // 下载
    async downloadGet(url, params = {}, customConfig, contentType = 'application/msword', pre = '/api',method = 'get') {
        return new Promise(async(resolve, reject) => {
            const response = await axios({
                url: baseUrl + pre + url,
                method: method,
                withCredentials: true,
                responseType: 'blob',
                params,
                headers: {
                    'Content-Type': contentType
                },
                validateStatus: function(status) {
                    return status >= 200 && status < 600
                }
            }).then(async(data) => {
                let flag = await DownloadRestResultDTO.showError(data)
                if (flag) {
                    const restResultDTO = DownloadRestResultDTO.from(data, customConfig)
                    resolve(restResultDTO)
                }

            })
        })
    },
    // put请求
    // 示例：req.put('/xxx', params, '/api', { timeout: 30000 })
    put(url, params = {}, pre = '/api', config = {}) {
        return new Promise((resolve, reject) => {
            axios.put(baseUrl + pre + url, params, { ...config })
                .then(response => { resolve(response.data) })
                .catch(err => { reject(err) })
        })
    },
    //医保post请求
    yibaoPost(url, params = {}, contentType = 'application/json;charset=UTF-8') {
        return new Promise((resolve, reject) => {
            axios.post(shebaoUrl + url, params, {
                    headers: { 'Content-Type': contentType },
                    validateStatus: function(status) {
                        return status >= 200 && status < 600
                    },
                })
                .then(response => { resolve(response.data) })
                .catch(err => { reject(err) })
        })
    },
    //语音请求
    voicePost(url, params = {}, contentType = 'application/json;charset=UTF-8') {
        return new Promise((resolve, reject) => {
            axios.post(voiceUrl + url, params, { headers: { 'Content-Type': contentType } })
                .then(response => { resolve(response.data) })
                .catch(err => { reject(err) })
        })
    },
     // get请求
    voiceGet(url, params = {},config = {}) {
        return new Promise((resolve, reject) => {
            axios.get(voiceUrl + url, {...config},{ params: params,} )
                .then(response => { resolve(response.data) })
                .catch(err => { reject(err) })
        })
    },
    // 打印请求
    printPost(url, params = {}, contentType = 'application/json;charset=UTF-8') {
        return new Promise((resolve, reject) => {
            axios.post(printUrl + url, params, { headers: { 'Content-Type': contentType } })
                .then(response => { resolve(response.data) })
                .catch(err => { reject(err) })
        })
    },
    // 报表统计- 导出报表函数
    exportSummary(url, params, fileName) {
        return new Promise((resolve, reject) => {
            axios({
                method: "post",
                url: url,
                data: params,
                responseType: "blob"
            }).then(res => {
                resolve()
                if (res.data.size > 0) {
                    const link = document.createElement('a');
                    let objectUrl = window.URL.createObjectURL(res.data); // 创建URL
                    link.href = objectUrl;
                    // link.download = fileName + '.xlsx'; // 自定义文件名
                    link.click(); // 下载文件
                    URL.revokeObjectURL(objectUrl); // 释放内存
                } else this.$message.warning('表格没有数据，无法下载！');
            });
        })

    },
    async blobDownload(url, params = {}, contentType = 'application/msword', pre = '/api',method = 'get') {
      return new Promise(async(resolve, reject) => {
          const response = await axios({
              url: baseUrl + pre + url,
              method: method,
              withCredentials: true,
              responseType: 'blob',
              params,
              headers: {
                  'Content-Type': contentType
              },
              validateStatus: function(status) {
                  return status >= 200 && status < 600
              }
          }).then(async(data) => {
            resolve(data)
          })
      })
  },

}

// 暴露请求对象
export default req;